export default __webpack_public_path__ + "static/media/DSC_0558.b84092b3.jpg";